import { Component, Input, ViewChild } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { Popup } from 'ng2-opd-popup';
import { environment } from 'environments/environment';
import { AdminService } from '../../../../services/admin';
declare var mdtoast: any;
var success_message3 = mdtoast("Evaluation Dr Vony", { duration: 5000, init: true, type: mdtoast.SUCCESS });


@Component({
  selector: 'app-modal-content',
  template: `
  <div class="modal-header" *ngIf="mode_body==1">
      <h5 class="modal-title text-center">   <font color="#0F7B79">{{nom_dr}}</font> </h5>
      <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
      </button>
  </div>

  <div class="modal-body" *ngIf="mode_body==1"> 
  <div class="text-center">
  <a href="{{urlfileIec_s}}" target="_blank" placement="bottom"  ngbTooltip="Manuel d'utilisation du site web du Centre Médico-Social du Ministère de l'Economie et des Finances.">
  <img src="assets/img/cms/logo_cms.png" class="img-rounded img-responsive" alt="Rounded Image">
  </a>
  <h4 class="text-center">
      <font color="#0F7B79">
       <figcaption>Nombres des visiteurs : {{nombre_visiteur}}</figcaption>  
      <figcaption> Date de mise à ligne : 23 Mars 2020</figcaption></font>      
  </h4>
</div>  

  </div>

  <div class="modal-footer" *ngIf="mode_body==1">
  <div class="left-side">
    
      <a href="{{urlfileIec_s}}" target="_blank"> MANUEL
      </a>
  </div>
  <div class="divider"></div>
  <div class="right-side">
      <button type="button" class="btn btn-danger btn-link" (click)="activeModal.close('Close click')">Fermer</button>
  </div>
</div>







<popup #popupManuel (confirmClick)="telecharger()">
    <div id="madiv">
        <pdf-viewer src="{{urlfileIec}}" [render-text]="true" style="display: block;"></pdf-viewer>
    </div>

</popup>



  `
})
//<button type="button" class="btn btn-default btn-link" (click)="manuel_tomady()">Manuel</button>
export class NgbdModalContent_Info {
  @Input() name;
  nom_dr: string = "Statistique des visiteurs";
  video_name: string = "dr_vony.mp4";
  urlfileIec: string;
  mode_body : number = 1;
  @ViewChild('popupManuel') popupManuel: Popup;
  urlfileIec__= environment.urlfileIec;
  urlfileIec_ :any = "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec/MANUEL_D_UTILISATION%20Site%20CMS.pdf";
   urlfileIec_s :any = "http://sysinfo.mef.gov.mg:8081/SiteCmsServeur/FileIEC/upload/file/iec/manuel_cms.pdf";
  Nombre_des_visiteurs: string;
  nombre_visiteur: any;
  constructor(public activeModal: NgbActiveModal, private router: Router,private adminService: AdminService) {
    this.adminService.getnombrevisiteur()
    .subscribe(data => {
      this.nombre_visiteur = data;
      this.Nombre_des_visiteurs = "Nombre des visiteurs";
    }, err => {

    })
  }



  Evaluation() {
    Swal.fire({
      title: 'Evaluation Dr Vony',
      icon: 'info',
      text: 'Réception, Disponibilité, niveau de concentretion, qualité de diagnostique, matériels,....',
      // icone: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui, Evalué!',
      cancelButtonText: 'Non'
    }).then((result) => {
      if (result.value) {
        //ok btn
        success_message3.show();
        this.activeModal.close('Close click')
        this.router.navigate(['evaluation/' + 92]);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        //cancel btn
      }
    });
  }

  manuel_tomady_() {
       this.mode_body = 2;
       this.urlfileIec = "assets/file/iec/MANUEL_D_UTILISATION Site CMS.pdf";
  }

  manuel_tomady() {
    this.popupManuel.options = {
      cancleBtnClass: "btn btn-default",
      confirmBtnClass: "btn btn-success",
      color: "#0F7B79",
      showButtons: true,
      animationDuration: 2.5,
      header: "Manuel d'utilisation Tomady",
      widthProsentage: 80,
      animation: "fadeInUp",
      confirmBtnContent: "Télécharger",
      cancleBtnContent: "Fermer",
    }
    
    this.urlfileIec = "assets/file/iec/MANUEL_D_UTILISATION Site CMS.pdf";
     this.mode_body = 2;
    //this.urlfileIec = "http://localhost/SiteCmsServeur/FileIEC/upload/file/iec/MANUEL_D_UTILISATION Site CMS.pdf";
    this.popupManuel.show(this.popupManuel.options);
    //this.activeModal.close('Close click')

  }

  telecharger() {
    //alefa le telechargement
    this.popupManuel.hide();
  }

}

@Component({
  selector: 'app-info-visiteur',
  templateUrl: './info-visiteur.component.html',
  styleUrls: ['./info-visiteur.component.scss']
})
export class InfoVisiteurComponent {
  constructor(private modalService: NgbModal) {
    const modalRef = this.modalService.open(NgbdModalContent_Info);
    modalRef.componentInstance.name = 'World';
  }

  ngOnInit() {
  }



}
